import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const SidePanel = ({ 
  isOpen = false, 
  onClose, 
  title, 
  children, 
  size = 'md',
  className = '' 
}) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-sm',     // 384px
    md: 'max-w-md',     // 448px
    lg: 'max-w-lg',     // 512px
    xl: 'max-w-xl',     // 576px
    '2xl': 'max-w-2xl', // 672px
    '3xl': 'max-w-3xl', // 768px
    '4xl': 'max-w-4xl', // 896px
    '5xl': 'max-w-5xl'  // 1024px
  };

  return (
    <>
      {/* Backdrop with blur effect - covers entire viewport including header */}
      <div
        className="fixed inset-0 bg-black/60 backdrop-blur-md transition-all duration-300 z-[9999]"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Panel - higher z-index to stay above backdrop */}
      <div
        className={`fixed inset-y-0 right-0 z-[10000] flex ${sizeClasses[size]} w-full ${className}`}
        role="dialog"
        aria-modal="true"
      >
        <div className="flex h-full w-full flex-col bg-white dark:bg-[#1a1a1a] shadow-2xl">
          {/* Header with proper border */}
          <div className="flex items-center justify-between border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-[#1a1a1a] px-6 py-4 shadow-sm">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h3>
            <button
              type="button"
              className="rounded-md text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 transition-colors"
              onClick={onClose}
            >
              <span className="sr-only">Close panel</span>
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto bg-white dark:bg-[#1a1a1a]">
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default SidePanel;